import React from 'react';

import { getClassNames } from '../../../utils/util';

import Image from '../image/Image';

import { ReactComponent as UserIcon } from '../../../resources/icons/user.svg';

import './profile-picture.scss';

type Props = {
  src: string | File | undefined;
  alt?: string;
  medium?: boolean;
  small?: boolean;
};

const ProfilePicture = ({ src, alt, medium, small }: Props) => {
  return (
    <div className={getClassNames('profile-picture', { medium, small })} data-testid="profile-picture">
      {src ? (
        <Image className={getClassNames('profile-picture__image', { medium, small })} src={src} alt={alt} />
      ) : (
        <UserIcon
          className={getClassNames('profile-picture__placeholder', { medium, small })}
          data-testid="profile-picture-placeholder"
        />
      )}
    </div>
  );
};

export default ProfilePicture;
